
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13 26c7.19 0 13-5.857 13-13 0-7.19-5.81-13-13-13S0 5.81 0 13c0 7.143 5.81 13 13 13zM7.691 12.167l3.289 3.392L18.309 8 20 9.744l-.14.146L10.98 19 6 13.863l1.691-1.696z","fill":"#EB690A","fill-rule":"nonzero"}})])
      }
    
      }
    